<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="items"
            :fields="fields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded"
        >
        </b-table>
    </div>
</template>

<script>
import RefundRequestService from "@/services/RefundRequestService";

/**
 * Refund Request Tab Component
 */
export default {
    name: 'RefundTab',
    data() {
        return {
            items: [],
            fields: [
                {
                    key: this.getLocaleField('program_name'),
                    label: this.toUpperCase('program'),
                },
                { key: 'account_holder', label: this.toUpperCase('account_holder') },
                { key: 'bank_name', label: this.toUpperCase('bank_name') },
                { key: 'branch_name', label: this.toUpperCase('branch_name') },
                { key: this.getLocaleField('reason_name'), label: this.toUpperCase('reason') },
                { key: this.getLocaleField('status_name'), label: this.toUpperCase('status') },
                { key: 'reason_for_rejection', label: this.toUpperCase('reason_for_rejection') },
                { key: 'created_at', label: this.toUpperCase('date') },
            ],
        };
    },
    methods: {
        fetchData() {
            RefundRequestService.studentRequests()
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(e => {
                    this.showErrors(e);
                });
        }
    },
    created() {
        this.fetchData();
    }
};
</script>
